import { useAuth0 } from '@auth0/auth0-react'

import { clearStoreToken } from '@flecto/api/src/services/tokens'

export function useUserLogout() {
  const { logout } = useAuth0()

  return (...params: Parameters<typeof logout>) => {
    clearStoreToken()
    logout(...params)
  }
}
